function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnFrecciaGiallo01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16,32c8.84,0,16-7.16,16-16S24.84,0,16,0,0,7.16,0,16s7.16,16,16,16",
    style: {
      fill: "#e5b440"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,4.4c-2.84,0-5.58,1.04-7.71,2.94l-.33.3,1.32,1.04.23-.2c1.81-1.56,4.11-2.42,6.49-2.42,5.48,0,9.94,4.46,9.94,9.94s-4.46,9.94-9.94,9.94-9.49-3.97-9.91-9.12h10.7l-4.17,3.27,1.02,1.3,6.88-5.4-6.88-5.4-1.02,1.3,4.17,3.27H4.79l-.36.03v.36c-.02.14-.03.29-.03.43,0,6.39,5.2,11.6,11.6,11.6s11.6-5.2,11.6-11.6-5.2-11.6-11.6-11.6v.02Z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnFrecciaGiallo01);
export default __webpack_public_path__ + "static/media/btn-freccia-giallo-01.4fe5394a093877078ed50477442d2765.svg";
export { ForwardRef as ReactComponent };